import BaseModal from '@/components/BaseModal';
import BoldText from '@/components/BoldText';
import QuickCopyText from '@/components/QuickCopyText';
import { messageTemplate } from '@/constants/string';
import { Icon, List } from '@shopify/polaris';
import { LightbulbIcon } from '@shopify/polaris-icons';
import { useState } from 'react';

const TipsAndTemplate = ({ onFocus, disabled }: { onFocus: () => void; disabled?: boolean }) => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [savedRange, setSavedRange] = useState<Range | null>(null);

  const handleAddText = (text: string) => {
    if (savedRange) {
      const selection = window.getSelection();
      selection?.removeAllRanges();
      selection?.addRange(savedRange);
    }

    onFocus();
    document.execCommand('insertHTML', false, text);
    setIsOpenModal(false);
  };

  const handleOpenModal = () => {
    const selection = window.getSelection();
    if (selection && selection.rangeCount > 0) {
      setSavedRange(selection.getRangeAt(0).cloneRange());
    }
    setIsOpenModal(true);
  };

  return (
    <div className="button-container tips-and-template">
      <button className="fn-btn" onClick={handleOpenModal} title="Tips and template" disabled={disabled}>
        <Icon source={LightbulbIcon} tone="base" />
        <span style={{ fontSize: '12px', fontWeight: '500' }}>Tips and template</span>
      </button>

      <BaseModal
        open={isOpenModal}
        onClose={() => {
          setIsOpenModal(false);
        }}
        title={
          <div className="d-flex" id={true ? 'editor-tips-template-container-id' : ''}>
            <Icon source={LightbulbIcon} />
            <div className="ml-8">Tips and template</div>
          </div>
        }
      >
        <BoldText>Tips: Reducing customer uncertainty and increasing conversion by including information about:</BoldText>
        <List>
          <List.Item>
            <BoldText>Estimated time</BoldText> for preparation, production, and delivery
          </List.Item>
          <List.Item>
            <BoldText>Countdown timer</BoldText> for sense of urgency to order or grab limited deals
          </List.Item>
          <List.Item>
            <BoldText>Highlighted services</BoldText> like packaging, guarantee, etc.
          </List.Item>
          <List.Item>
            <BoldText>Additional cost</BoldText> with different delivery options
          </List.Item>
          <List.Item>
            <BoldText>Possible issues</BoldText> affecting delivery times like high demand, different locations, logistical
            delays, etc.
          </List.Item>
        </List>
        <hr />

        <BoldText>Message template</BoldText>
        {messageTemplate.map((text) => (
          <QuickCopyText
            key={text}
            text={text}
            onClick={() => {
              handleAddText('<br>' + text);
            }}
          />
        ))}
      </BaseModal>
    </div>
  );
};

export default TipsAndTemplate;
